// extracted by mini-css-extract-plugin
module.exports = {"page":"Page-module--page--3oOuh","header":"Page-module--header--3WYgk","metadata":"Page-module--metadata--1sa2G","main":"Page-module--main--1Upif"};